import type { ReactNode } from 'react';

import LandingFooter from '@/components/landing/LandingFooter';
import LandingHeader from '@/components/landing/LandingHeader';
import type { FooterLandingPage } from '@/sanity/landing-page';
import type { LegalLink } from '@/utils/legal-links';

type DirectoryPageShellProps = {
  children: ReactNode;
  footerLandingPages: readonly FooterLandingPage[];
  footerLegalLinks: readonly LegalLink[];
  headerCallToAction?: {
    label: string;
    sectionId: string;
  };
  version?: 'v2';
};

const DirectoryPageShell = ({
  children,
  footerLandingPages,
  footerLegalLinks,
  headerCallToAction,
  version,
}: DirectoryPageShellProps) => (
  <div className="min-h-screen bg-canvas text-ink">
    <LandingHeader callToAction={headerCallToAction} />
    <div className="mx-auto flex max-w-[1160px] flex-col px-[clamp(20px,4vw,48px)]">
      <main data-page-version={version}>{children}</main>
      <LandingFooter
        landingPages={footerLandingPages}
        legalLinks={footerLegalLinks}
      />
    </div>
  </div>
);

export default DirectoryPageShell;
